import * as React from 'react';

interface Props {
  className: string;
}

const ArrowIcon: React.FC<Props> = ({ className }) => (
  <div className={className}>
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="18" viewBox="0 0 9 18" fill="none">
      <path
        opacity="0.8"
        d="M1.30228 0.731689L0 2.11167L5.73877 8.99322L0 15.8748L1.30228 17.2684L7.84618 9.31689L8.1096 8.99322L7.84618 8.66954L1.30228 0.731689Z"
        fill="#2B2B2B"
      />
    </svg>
  </div>
);

export default ArrowIcon;
